module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0135.jpg?v=f6f5b54f";